import React from 'react';
import { Box, Col, Row } from '@saucelabs/sl-component-grid';
import { IconBulletPlus } from '@saucelabs/sl-component-icons';
import { Button } from '@saucelabs/ds-button';
import { IconAutomatedOutline, IconPlusOutline } from '@saucelabs/ds-icons';

import { PriceColumn } from '../PriceColumn';
import { SectionTitle } from '../../Layout/SectionTitle';
import { FeatureList } from '../../Plans/FeatureList';

interface AutomatedTileProps {
  onProductAdd: void
  price: number
}
const AutomatedTile: React.FC<AutomatedTileProps> = ({ onProductAdd, price, children }) => (
  <Box.Section className="text-high-emphasis">
    <SectionTitle subtitle="Suitable for teams who are looking to automate their testing processes.">
      <IconAutomatedOutline className="h-3 fill-current text-gray-500" />
      Automated + Live Testing
    </SectionTitle>
    <Row between="xs">
      <Col xs>
        <>
          <div className="mt-2 mb-1">
            <strong>Includes everything in Live, plus:</strong>
          </div>
          <FeatureList>
            <li>
              <IconBulletPlus />
              Mobile App Automated Testing
            </li>
            <li>
              <IconBulletPlus />
              Local &amp; JavaScript Testing
            </li>
            <li>
              <IconBulletPlus />
              Performance, Insights, &amp; Analytics
            </li>
            <li>
              <IconBulletPlus />
              Secure Tunneling &amp; APIs
            </li>
          </FeatureList>
        </>
      </Col>
      <PriceColumn
        price={price}
      >
        <Button
          color="primary"
          elementType="button"
          onClick={onProductAdd}
          prefixIcon={<IconPlusOutline />}
          size="md"
          type="button"
          variant="outline"
        >
          Add Plan
        </Button>
      </PriceColumn>
    </Row>
    {children}
  </Box.Section>
);

export { AutomatedTile };
